var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vuestic-tag",class:_vm.tagClass},[_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),(_vm.removable)?_c('span',{staticClass:"vuestic-tag-button",on:{"click":_vm.remove}},[_c('i',{staticClass:"ion-md-close ion"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b1bf830","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestic-components/vuestic-tag/VuesticTag.vue
// module id = LmDz
// module chunks = 273